import { LineStyle } from '../../modules/channel/models';

export interface LineStyleOption {
	lineStyle?: LineStyle;
	label?: string;
}
